/* eslint-disable no-unused-vars */
import { Box, Button, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import account from '../services/account-service';

const PREFIX = 'ProfilePage';
const classes = {
  root: `${PREFIX}-root`,
  form: `${PREFIX}-form`
};
const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#0F1117'
  },
  [`& .${classes.form}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
}));

export default function ProfilePage() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  useEffect(() => {
    const fetchUser = async () => {
      const response = await account.getUser();
      if (response.success) {
        console.log(response);
        setUsername(response.result.user.username);
        setEmail(response.result.user.email);
        setFirstName(response.result.user.first_name || '');
        setLastName(response.result.user.last_name || '');
      } else {
        console.error(response.reason);
      }
    };
    fetchUser();
  }, []);

  const handleSave = async () => {
    if (password !== confirmPassword) {
      alert('Passwords do not match!');
      return;
    }

    // Name and email were never sent — handleSave built a body containing only
    // the password, so editing them appeared to succeed and silently changed
    // nothing. Field names are snake_case to match editUserBody on the API.
    const body = {
      first_name: firstName,
      last_name: lastName,
      email: email
    };

    // Only include the password when the user actually set one. Sending an
    // empty string fails the API's min(6) rule, which is why saving a
    // name-only edit returned a confusing password-length error.
    if (password) {
      body.password = password;
    }

    const response = await account.updateUser(body);

    if (response.success) {
      alert('Profile updated successfully!');
    } else {
      console.error(response.reason);
      alert('Failed to update profile. Please try again.');
    }
  };

  return (
    <div style={{ width: '80%', margin: 'auto', marginTop: '20px' }}>
      <Root className={classes.root}>
        <Box
          component="form"
          className={classes.form}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="first-name"
            label="First Name"
            variant="outlined"
            margin="normal"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <TextField
            id="last-name"
            label="Last Name"
            variant="outlined"
            margin="normal"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          <TextField
            id="email"
            label="Email"
            variant="outlined"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            margin="normal"
            disabled={true}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            id="password"
            label="Change Password"
            type="password"
            variant="outlined"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            id="confirm-password"
            label="Confirm Password"
            type="password"
            variant="outlined"
            margin="normal"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <Button variant="contained" color="primary" onClick={handleSave}>
            Save
          </Button>
        </Box>
      </Root>
    </div>
  );
}
